import './NewsSummary.css'

import Image from 'next/image'
import router from 'next/router'
import { FC } from 'react'

import { Feed } from '@/api/models/news/lib/news.types'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import SmallZipZapIconSvg from '@/assets/svg/SmallZipZapIcon.svg'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'
import { formatFeedDate } from '@/utils/datetime'

type Props = {
  newsItem: Feed
}

const NewsSummaryCard: FC<Props> = ({ newsItem }) => {
  const { reachGoal } = useYandexMetrika()

  const onCardClick = () => {
    reachGoal(YandexMetrikaEvent.MAIN_NEWS_DETAIL)
    router.push(`/feed/${newsItem.id}?type=news`)
  }

  return (
    <button
      className="mb-12 block w-full cursor-pointer rounded-12 bg-grey-10 text-left transition-all hover:bg-beige-20 sm:bg-white"
      onClick={onCardClick}
    >
      <div className="flex">
        <div className="relative flex h-[136px] w-[181px] flex-shrink-0 overflow-hidden rounded-s-12">
          <Image
            className="object-cover"
            src={newsItem.picture}
            fill
            alt={newsItem.shortTitle}
          />
        </div>
        <div className="flex w-full flex-col justify-between p-16">
          <p className="wrap-anywhere line-clamp-3 font-semibold text-grey-100 text-18 xs:text-16">
            {newsItem.shortTitle}
          </p>
          <div className="flex items-end justify-between">
            <p className="font-pro text-grey-70 text-14">
              {formatFeedDate(newsItem.date, 'DD MMMM')}
            </p>
            {newsItem.isImportant && (
              <SmallZipZapIconSvg className="h-20 w-20" />
            )}
          </div>
        </div>
      </div>
    </button>
  )
}

export default NewsSummaryCard
